<template>
  <div class="announcement">
    <div class="section hero-grey">
      <div class="container">
        <div class="center">
          <h2 class="h2 margin">CONVOCATORIAS PÚBLICAS EN LAS ESCUELAS SUPERIORES DE FORMACIÓN DE MAESTRAS Y MAESTROS</h2>
          
        </div>
      </div>
    </div>
    <div class="section padding-bottomss">
      <div class="container" v-for="(item, index) in convocatorias_esfm" :key="index">
        <h3 class="h2 margin">{{item.esfm}}</h3>
        <div data-duration-in="300" data-duration-out="100" class="tabs w-tabs">
          <div class="tabs-content w-tab-content">
            <div class="w-tab-pane">
              <div class="main-container">
                <div class="card-container" v-if="item.convocatorias.length > 0">
                  <div
                    class="card" style="display: block;"
                    v-for="(item, index) in item.convocatorias"
                    :key="index"
                    :class="index == 0 ? 'card_bg' : ''"
                  >
                    <small class="textss"
                      >Fecha: {{ item.created_at | formatdate }}
                    </small>
                    <h5 class="card__titles">
                      {{ item.cite }}
                      <br/>
                    </h5>
                    <p class="card_description margins">
                      {{ item.descripcion }}
                    </p>
                    <p class="card__applys">
                      <a
                        :href="`${serve}/convocatorias/${item.documento}`"
                        class="btn-download text-small"
                        target="_blank"
                        download
                        >Descargar <i class="fas fa-arrow-right"></i
                      ></a>
                    </p>
                  </div>
                </div>
                <div class="card-container" v-else>
                  <div class="alert">
                    <span class="text-red"
                      >No existen {{ tipo_normativa }} publicados</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </div>
  </div>
</template>

<script>
import Service from "../router/endpoint";
// import axios from "axios";
export default {
  name: "announcement",
  data() {
    return {
      loading: false,
      tipo_normativas: [],
      convocatorias_esfm: [],
      tab: 2,
      tipo_normativa: "Instructivos",
      gestion: "",
      serve: "",
    };
  },
  mounted() {
    this.serve = Service.getServe();
    this.gestion = new Date().getFullYear();
    this.getNormativas(this.tab);
  },
  methods: {
    

    getNormativas() {
      this.normativas = [];
      this.loading = true;
      this.convocatorias_esfm = [
        {
          cod_esfm:201,
          esfm : 'ESFM "SIMÓN BOLÍVAR"', 
          convocatorias:[
          {
            created_at:'06/05/2026',
            cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN BOLÍVAR" No. 002/2026',
            descripcion:'COMPULSA DE MERITOS PROFESIONALES PARA OPTAR CARGO CATEDRATICO - DOCENTE EN LA ESCUELA SUPERIOR DE FORMACION DE MAESTRAS Y MAESTROS “SIMON BOLIVAR” DEL DEPARTAMENTO DE LA PAZ',
            documento:'convocatoria_201_002_2026.pdf'
          },

          {created_at:'14/10/2025',
              cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN BOLÍVAR" No. 007/2025',
                descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "SIMÓN BOLÍVAR" DEL DEPARTAMENTO DE LA PAZ',
              documento:'convocatoria_201_007_2025.pdf'
            },
           {created_at:'07/10/2025',
              cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN BOLÍVAR" No. 006/2025',
                descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "SIMÓN BOLÍVAR" DEL DEPARTAMENTO DE LA PAZ',
              documento:'convocatoria_201_006_2025.pdf'
            },
          {created_at:'06/10/2025',
              cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN BOLÍVAR" No. 005/2025',
                descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "SIMÓN BOLÍVAR" DEL DEPARTAMENTO DE LA PAZ',
              documento:'convocatoria_201_005_2025.pdf'
            },
            {created_at:'06/10/2025',
              cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN BOLÍVAR" No. 004/2025',
                descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "SIMÓN BOLÍVAR" DEL DEPARTAMENTO DE LA PAZ',
              documento:'convocatoria_201_004_2025.pdf'
            },
            {created_at:'18/07/2025',
              cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN BOLÍVAR" No. 003/2025',
                descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO DE SERVICIO EN LA UNIDAD ACADÉMICA "CARANAVI" DEPENDIENTE DE LA ESFM "SIMÓN BOLÍVAR" DEL DEPARTAMENTO DE LA PAZ',
              documento:'convocatoria_201_003_2025.pdf'
            },
            {created_at:'01/07/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN BOLÍVAR" No. 002/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO DE SERVICIO EN LA UNIDAD ACADÉMICA "CARANAVI" DEPENDIENTE DE LA ESFM "SIMÓN BOLÍVAR" DEL DEPARTAMENTO DE LA PAZ',
            documento:'convocatoria_201_002_2025.pdf'
            },
             {created_at:'24/06/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN BOLÍVAR" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "SIMÓN BOLÍVAR" DEL DEPARTAMENTO DE LA PAZ',
            documento:'convocatoria_201_001_2025.pdf'
            }
          ] 
        },
      {
          cod_esfm:101,
          esfm : 'ESFM "MARISCAL SUCRE"', 
          convocatorias:[
            {created_at:'03/10/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "MARISCAL SUCRE" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO DE SERVICIO EN LA ESFM "MARISCAL SUCRE" DEL DEPARTAMENTO DE CHUQUISACA',
            documento:'convocatoria_101_001_2025.pdf'
            }
          ] 
        },
          {
          cod_esfm:302,
          esfm : 'ESFM "MANUEL ASCENCIO VILLARROEL"',
          convocatorias:[
            {
              created_at:'06/05/2026',
              cite:'CONVOCATORIA PÚBLICA ESFM "MANUEL ASCENCIO VILLARROEL" No. 001/2026',
              descripcion:'COMPULSA DE MERITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACIÓN DE MAESTRAS Y MAESTROS "MANUEL ASCENCIO VILLARROEL" DEL DEPARTAMENTO DE COCHABAMBA',
              documento:'convocatoria_302_001_2026.pdf'
            }
          ]
        },
         {
          cod_esfm:207,
          esfm : 'ESFM "VILLA AROMA"', 
          convocatorias:[
            {
              created_at:'06/05/2026',
              cite:'CONVOCATORIA PÚBLICA ESFM "VILLA AROMA" No. 003/2026',
              descripcion:'COMPULSA DE MERITOS PROFESIONALES PARA OPTAR CARGO DE SERVICIO EN LA ESCUELA SUPERIOR DE FORMACION DE MAESTRAS Y MAESTROS “VILLA AROMA” DEL DEPARTAMENTO DE LA PAZ',
              documento:'convocatoria_207_003_2026.pdf'
            },
            {created_at:'01/10/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "VILLA AROMA" No. 003/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACIÓN DE MAESTRAS Y MAESTROS "VILLA AROMA" DEL DEPARTAMENTO DE LA PAZ',
            documento:'convocatoria_207_003_2025.pdf'
            },
            {created_at:'01/10/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "VILLA AROMA" No. 002/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO SERVICIO EN LA ESCUELA SUPERIOR DE FORMACIÓN DE MAESTRAS Y MAESTROS "VILLA AROMA" DEL DEPARTAMENTO DE LA PAZ',
            documento:'convocatoria_207_002_2025.pdf'
            },
            {created_at:'23/09/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "VILLA AROMA" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACIÓN DE MAESTRAS Y MAESTROS "VILLA AROMA" DEL DEPARTAMENTO DE LA PAZ',
            documento:'convocatoria_207_001_2025.pdf'
            }
          ] 
        },
      {
          cod_esfm:703,
          esfm : 'ESFM "RAFAEL CHAVEZ ORTIZ"', 
          convocatorias:[
            {created_at:'01/10/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "RAFAEL CHAVEZ ORTIZ" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO CATEDRATICO-DOCENTE EN LA ESCUELA SUPERIOR DE FORMACIÓN DE MAESTRAS Y MAESTROS "RAFAEL CHÁVEZ ORTIZ" DEL DEPARTAMENTO DE SANTA CRUZ',
            documento:'convocatoria_703_001_2025.pdf'
            }
          ] 
        },
      {
          cod_esfm:801,
          esfm : 'ESFM "CLARA PARADA DE PINTO"', 
          convocatorias:[
            {
              created_at:'06/05/2026',
              cite:'CONVOCATORIA INTERNA ESFM "CLARA PARADA DE PINTO" No. 002/2026',
              descripcion:'COMPULSA DE MERITOS PROFESIONALES PARA OPTAR CARGO DE CATEDRATICO - DOCENTE Y ADMINISTRATIVO DE LA ESCUELA SUPERIOR DE FORMACION DE MAESTROS “CLARA PARADA DE PINTO” DEL DEPARTAMENTO DE BENI',
              documento:'convocatoria_801_002_2026.pdf'
            },
            {created_at:'25/09/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "CLARA PARADA DE PINTO" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACIÓN DE MAESTRAS "CLARA PARADA DE PINTO" DEL DEPARTAMENTO DE BENI',
            documento:'convocatoria_801_001_2025.pdf'
            }
          ] 
        },
         {
          cod_esfm:103,
          esfm : 'ESFM "FRANZ TAMAYO"', 
          convocatorias:[
            {created_at:'06/05/2026',
            cite:'CONVOCATORIA PÚBLICA ESFM "FRANZ TAMAYO" DE LLICA No. 002/2026',
            descripcion:'COMPULSA INTERNA DE MERITOS PROFESIONALES PARA OPTAR CARGO DE DOCENTE - CATEDRATICO EN LA ESCUELA SUPERIOR DE FORMACION DE MAESTROS “FRANZ TAMAYO” DE LLICA DEPARTAMENTO DE POTOSI',
            documento:'convocatoria_103_002_2026.pdf'
            }
          ] 
        },
      
        {
          cod_esfm:701,
          esfm : 'ESFM "ENRIQUE FINOT"', 
          convocatorias:[
           {
            created_at:'06/05/2026',
            cite:'CONVOCATORIA PÚBLICA ESFM "ENRIQUE FINOT" No 003/2026',
            descripcion:'COMPULSA INTERNA DE MERITOS PROFESIONALES PARA CARGOS ACEFALOS A LA CONVOCATORIA PUBLICA ESFM/UA 003/2026. PARA OPTAR CARGO PERSONAL DE SERVICIO EN LA ESFM “ENRIQUE FINOT" DEL DEPARTAMENTO DE SANTA CRUZ',
            documento:'convocatoria_701_003_2026.pdf'
           },
           {created_at:'23/09/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "ENRIQUE FINOT" No. 004/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO DE SERVICIO EN LA UNIDAD ACADÉMICA "VALLEGRANDE" DEPENDIENTE DE LA ESFM "ENRIQUE FINOT" DEL DEPARTAMENTO DE SANTA CRUZ',
            documento:'convocatoria_701_004_2025.pdf'
            },
            {created_at:'08/09/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "ENRIQUE FINOT" No. 003/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO DE SERVICIO EN LA UNIDAD ACADÉMICA "VALLEGRANDE" DEPENDIENTE DE LA ESFM "ENRIQUE FINOT" DEL DEPARTAMENTO DE SANTA CRUZ',
            documento:'convocatoria_701_003_2025.pdf'
            },
            {created_at:'01/09/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "ENRIQUE FINOT" No. 002/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO DE SERVICIO EN LA UNIDAD ACADÉMICA "VALLEGRANDE" DEPENDIENTE DE LA ESFM "ENRIQUE FINOT" DEL DEPARTAMENTO DE SANTA CRUZ',
            documento:'convocatoria_701_002_2025.pdf'
            },
             {created_at:'27/05/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "ENRIQUE FINOT" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO CATEDRÁTICO - DOCENTE EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "ENRIQUE FINOT" DEL DEPARTAMENTO DE SANTA CRUZ',
            documento:'convocatoria_701_001_2025.pdf'
            }
          ] 
        },
         {
          cod_esfm:401,
          esfm : 'ESFM "ÁNGEL MENDOZA JUSTINIANO"', 
          convocatorias:[
          {created_at:'08/09/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "ÁNGEL MENDOZA JUSTINIANO" No. 003/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "ÁNGEL MENDOZA JUSTINIANO" DEL DEPARTAMENTO DE ORURO',
            documento:'convocatoria_401_003_2025.pdf'
            }, 
          {created_at:'05/09/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "ÁNGEL MENDOZA JUSTINIANO" No. 002/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "ÁNGEL MENDOZA JUSTINIANO" DEL DEPARTAMENTO DE ORURO',
            documento:'convocatoria_401_002_2025.pdf'
            },
             {created_at:'01/09/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "ÁNGEL MENDOZA JUSTINIANO" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "ÁNGEL MENDOZA JUSTINIANO" DEL DEPARTAMENTO DE ORURO',
            documento:'convocatoria_401_001_2025.pdf'
            }
          ] 
        },
  
        
        {
          cod_esfm:505,
          esfm : 'ESFM "JOSÉ DAVID BERRIOS"', 
          convocatorias:[
            {created_at:'05/09/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "JOSÉ DAVID BERRIOS" No. 002/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESFM "JOSÉ DAVID BERRIOS" DEL DEPARTAMENTO DE POTOSÍ',
            documento:'convocatoria_505_002_2025.pdf'
            },
            {created_at:'23/06/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "JOSÉ DAVID BERRIOS" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO CATEDRÁTICO - DOCENTE EN LA ESFM "JOSÉ DAVID BERRIOS" DEL DEPARTAMENTO DE POTOSÍ',
            documento:'convocatoria_505_001_2025.pdf'
            }
          ] 
        },
         
      {
          cod_esfm:305,
          esfm : 'ESFM "SIMÓN RODRIGUEZ"', 
          convocatorias:[
          {
            created_at:'06/05/2026',
            cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN RODRIGUEZ" No. 002/2026',
            descripcion:'COMPULSA DE MERITOS PROFESIONALES PARA OPTAR CARGO DE CATEDRATICO - DOCENTE y ADMINIATRATIVO EN LA UNIDAD ACADEMICA “VILLA TUNARI” DEPENDIENTE DE LA ESFM “SIMON RODRIGUEZ” DEL DEPARTAMENTO DE COCHABAMBA',
            documento:'convocatoria_305_002_2026.pdf'
          },
          {created_at:'22/08/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN RODRIGUEZ" No. 004/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO CATEDRÁTICO - DOCENTE EN LA UNIDAD ACADÉMICA "CERCADO" DEPENDIENTE DE LA ESFM "SIMÓN RODRIGUEZ" DEL DEPARTAMENTO DE COCHABAMBA',
            documento:'convocatoria_305_004_2025.pdf'
            },
            {created_at:'18/08/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN RODRIGUEZ" No. 003/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO CATEDRÁTICO - DOCENTE EN LA UNIDAD ACADÉMICA "CERCADO" DEPENDIENTE DE LA ESFM "SIMÓN RODRIGUEZ" DEL DEPARTAMENTO DE COCHABAMBA',
            documento:'convocatoria_305_003_2025.pdf'
            },
             {created_at:'30/06/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN RODRIGUEZ" No. 002/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO CATEDRÁTICO - DOCENTE EN LA UNIDAD ACADÉMICA "VILLA TUNARI" DEPENDIENTE DE LA ESFM "SIMÓN RODRIGUEZ" DEL DEPARTAMENTO DE COCHABAMBA',
            documento:'convocatoria_305_002_2025.pdf'
            },
            {created_at:'23/06/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "SIMÓN RODRIGUEZ" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO DE SERVICIO EN LA UNIDAD ACADÉMICA "CERCADO" DEPENDIENTE DE LA ESFM "SIMÓN RODRIGUEZ" DEL DEPARTAMENTO DE COCHABAMBA',
            documento:'convocatoria_305_001_2025.pdf'
            }
          ] 
        },
      {
          cod_esfm:901,
          esfm : 'ESFM "PUERTO RICO"', 
          convocatorias:[
            {created_at:'07/05/2026',
            cite:'CONVOCATORIA PÚBLICA ESFM "PUERTO RICO" No. 001/2026',
              descripcion:'COMPULSA DE MERITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACION DE MAESTRAS Y MAESTROS "PUERTO RICO" UNIDAD ACADEMICA FILADELFIA DEL DEPARTAMENTO DE PANDO',
            documento:'convocatoria_901_001_2026.pdf'
            },
            {created_at:'22/08/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "PUERTO RICO" No. 003/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESFM "PUERTO RICO" DEL DEPARTAMENTO DE PANDO',
            documento:'convocatoria_901_003_2025.pdf'
            },
            {created_at:'29/07/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "PUERTO RICO" No. 002/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO CATEDRÁTICO - DOCENTE EN LA ESFM "PUERTO RICO" DEL DEPARTAMENTO DE PANDO',
            documento:'convocatoria_901_002_2025.pdf'
            },
            {created_at:'23/06/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "PUERTO RICO" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO CATEDRÁTICO - DOCENTE EN LA UNIDAD ACADÉMICA "FILADELFIA" DEPENDIENTE DE LA ESFM "PUERTO RICO" DEL DEPARTAMENTO DE PANDO',
            documento:'convocatoria_901_001_2025.pdf'
            }
          ] 
        },
        
       {
          cod_esfm:402,
          esfm : "ESFM CARACOLLO", 
          convocatorias: [
           {created_at:'14/08/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "CARACOLLO" No. 004/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESFM "CARACOLLO" DEL DEPARTAMENTO DE ORURO',
            documento:'convocatoria_402_004_2025.pdf'
            },
            {created_at:'23/06/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "CARACOLLO" No. 003/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA UNIDAD ACADÉMICA "MACHACAMARCA" DEPENDIENTE DE LA ESFM "CARACOLLO" DEL DEPARTAMENTO DE ORURO',
            documento:'convocatoria_402_003_2025.pdf'
            },
             {created_at:'06/05/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "CARACOLLO" No. 002/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACIÓN DE MAESTRAS Y MAESTROS "CARACOLLO" DEL DEPARTAMENTO DE ORURO',
            documento:'convocatoria_402_002_2025.pdf'
            }
          ]
        },
        {
          cod_esfm:203,
          esfm : 'ESFM "SANTIAGO DE HUATA"', 
          convocatorias:[
            {created_at:'01/08/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "SANTIAGO DE HUATA" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO DE SERVICIO EN LA ESFM "SANTIAGO DE HUATA" DEL DEPARTAMENTO DE LA PAZ',
            documento:'convocatoria_203_001_2025.pdf'
            }
          ] 
        },
       
      
         {
          cod_esfm:301,
          esfm : 'ESFM "ISMAEL MONTES"', 
          convocatorias:[
            {created_at:'23/06/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "ISMAEL MONTES" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "ISMAEL MONTES" DEL DEPARTAMENTO DE COCHABAMBA',
            documento:'convocatoria_301_001_2025.pdf'
            }
          ] 
        },
        {
          cod_esfm:503,
          esfm : 'ESFM "MCAL. ANDRÉS DE SANTA CRUZ" - CHAYANTA', 
          convocatorias:[
            {created_at:'26/05/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "MCAL. ANDRÉS DE SANTA CRUZ" - CHAYANTA No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO CATEDRÁTICO - DOCENTE EN LA UNIDAD ACADÉMICA "SAN LUIS DE SACACA" DEPENDIENTE DE LA ESFM "MCAL. ANDRÉS DE SANTA CRUZ" - CHAYANTA DEL DEPARTAMENTO DE POTOSÍ',
            documento:'convocatoria_503_001_2025.pdf'
            }
          ] 
        },
        {
          cod_esfm:205,
          esfm : 'ESFM "EDUARDO AVAROA"', 
          convocatorias:[
            {created_at:'26/05/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "EDUARDO AVAROA" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO CATEDRÁTICO - DOCENTE EN LA UNIDAD ACADÉMICA "ATOCHA-TELAMAYU" DEPENDIENTE DE LA ESFM "EDUARDO AVAROA" DEL DEPARTAMENTO DE POTOSÍ',
            documento:'convocatoria_501_001_2025.pdf'
            }
          ] 
        },
        {
          cod_esfm:205,
          esfm : 'ESFM DE EDUCACIÓN FÍSICA Y DEPORTES "ANTONIO JOSÉ DE SUCRE"', 
          convocatorias:[
            {created_at:'26/05/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM DE EDUCACIÓN FÍSICA Y DEPORTES "ANTONIO JOSÉ DE SUCRE" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS DE EDUCACIÓN FÍSICA Y DEPORTES "ANTONIO JOSÉ DE SUCRE" DEL DEPARTAMENTO DE LA PAZ',
            documento:'convocatoria_205_001_2025.pdf'
            }
          ] 
        },
        {
          cod_esfm:204,
          esfm : "ESFM MCAL. ANDRÉS DE SANTA CRUZ Y CALAHUMANA", 
          convocatorias:[
            {created_at:'07/05/2025',
            cite:'CONVOCATORIA PÚBLICA No. 002/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO SERVICIO MÚLTIPLE EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "MCAL. ANDRÉS DE SANTA CRUZ y CALAHUMANA" DEL DEPARTAMENTO DE LA PAZ',
            documento:'convocatoria_204_002_2025.pdf'
            },
            {created_at:'17/04/2025',
            cite:'CONVOCATORIA PÚBLICA No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "MCAL. ANDRÉS DE SANTA CRUZ y CALAHUMANA" DEL DEPARTAMENTO DE LA PAZ',
            documento:'convocatoria_204_001_2025.pdf'
            }
          ] 
        },
        {
          cod_esfm:802,
          esfm : "ESFM RIBERALTA", 
          convocatorias: [
            {created_at:'30/04/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "RIBERALTA" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACiÓN DE MAESTRAS Y MAESTROS "RIBERALTA" DEPARTAMENTO BENI',
            documento:'convocatoria_802_001_2025.pdf'
            }
          ]
        },
        {
          cod_esfm:704,
          esfm : "ESFM MULTIÉTNICA INDÍGENA DE CONCEPCIÓN", 
          convocatorias: [
            {created_at:'23/05/2025',
            cite:'CONVOCATORIA PÚBLICA ESFM "MULTIÉTNICA INDÍGENA DE CONCEPCIÓN" No. 001/2025',
              descripcion:'COMPULSA DE MÉRITOS PROFESIONALES PARA OPTAR CARGO ADMINISTRATIVO EN LA ESCUELA SUPERIOR DE FORMACIÓN DE MAESTRAS Y MAESTROS "MULTIÉTNICA INDÍGENA DE CONCEPCIÓN" DEPARTAMENTO DE SANTA CRUZ',
            documento:'convocatoria_704_001_2025.pdf'
            }
          ]
        }
      ]
      // axios
      //   .post(
      //     Service.getBase() + "lista/normativas",
      //     { tipo_normativa_id: this.tab, gestion: this.gestion },
      //     Service.getHeader()
      //   )
      //   .then((response) => {
      //     this.loading = false;
      //     this.normativas = response.data;
      //   })
      //   .catch((error) => {
      //     this.loading = false;
      //     console.error("Error al cargar registros", error);
      //   });
    },

  },
};
</script>

<style scoped></style>
